import {useCallback} from 'react';
import {useGetCategories} from '~/common/components/MegaNav/MegaNavVariant/hooks/useGetCategories';
import {TabsEnum} from '~/common/components/MegaNav/MegaNavVariant/types';
import {Link} from '~library/atoms/Link';
import {Typography} from '~library/atoms/Typography';
import {useTracking} from '~library/context/tracking/tracking-context';
import * as styles from './EvitePro.module.scss';

export const EvitePro = () => {
  const {megaNavData} = useGetCategories();
  const eviteProData = megaNavData?.globalNav.find((el) => el.id === TabsEnum.PRO);
  const {track} = useTracking();

  const handleProClick = useCallback(() => {
    track({
      dataQaId: 'get-evite-pro',
      href: eviteProData?.url || '/pro',
    });
  }, [eviteProData?.url, track]);

  return (
    <div className={styles.containerWrapper}>
      <div className={styles.content}>
        <img
          src="https://g0.evitecdn.com/marketing/meganav/dropdown_tiles/dropdown-tile-business-evite-pro.png"
          alt="evite logo"
          className={styles.image}
        />
        <div className={styles.info}>
          <Typography variant="paragraph2">
            Subscribe to get unlimited Premium Invitations & Greeting Cards for one set price!
          </Typography>
          <Link
            data-qa-id="get-evite-pro"
            href={eviteProData?.url || '/pro'}
            className={styles.cta}
            onClick={handleProClick}
          >
            Get Evite Pro
          </Link>
        </div>
      </div>
    </div>
  );
};
